import request from "@/utils/request";

export function all(id) {
  return request.get(`/cards?loyalty`, { data: null });
}

export function create(id, number) {
  return request.post(`/cards?loyalty`, { code: number });
}

export function lock(id) {
  return request.patch(`/cards/${id}/lock?loyalty`);
}

export function reportStolen(id) {
  return request.patch(`/cards/${id}/report-stolen?loyalty`);
}
